import { useTranslation } from 'react-i18next'

import { BaseModal } from '@/components/Modal/Modal'

import styles from './BasketTypeGuideModal.module.scss'
import { CURRICULUM_BASKET_TYPES } from '../constants/curriculum-basket-type'

type BasketTypeGuideModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const BasketTypeGuideModal = (props: BasketTypeGuideModalProps) => {
  const { t } = useTranslation('curriculumsManagement')

  return (
    <BaseModal
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={t('header.basket-type-guide')}
    >
      <ul className={styles.list}>
        {CURRICULUM_BASKET_TYPES.map(option => (
          <li className={styles.listItem} key={option}>
            <h3 className={styles.header}>{t(`basket-type.${option}`)}</h3>
            <p className={styles.description}>
              {t(`help.${option}-basket-description`)}
            </p>
          </li>
        ))}
      </ul>
    </BaseModal>
  )
}

export default BasketTypeGuideModal
